import { createFileRoute } from '@tanstack/react-router';

import { AdminSettingsPage } from '@pages/admin';

export const Route = createFileRoute('/$locale/_authenticated/admin/settings/')({
  component: AdminSettings,
});

function AdminSettings() {
  return <AdminSettingsPage />;
}
